export const shareProp = {
  twitter: {
    icon: ['fab', 'x-twitter'],
    color: '#1E3050'
  },
  sms: {
    icon: ['fas', 'comment-sms'],
    color: '#25d366'
  }
};
